<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <div class="prev">
    <a [routerLink]="prev" *ngIf="prev"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>Level {{ level }}</h2>
  <div class="next">
    <a [routerLink]="next" *ngIf="next">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-right']"></fa-icon></span
    ></a>
  </div>
</nav>

<div class="container container-inner container-content" *ngIf="exercise">
  <div class="row">
    <div class="col">

        <video
       
        width="100%"
        style="max-height:80vh;"
        controls
        preload
        class="mt-4 fade-in mb-4"
        controlsList="nodownload"
        [src]="getVideo(exercise.video)"
        autoplay
        poster="/assets/img/video-poster.jpg"
      >
      </video>


      <h3 class="text-center mt-4 mb-3">{{exercise.area}} : {{exercise.title}}</h3>
     
      
    </div>
  </div>
  <div class="row" *ngIf="levelExercises">
    <div class="col-12">
      <h3 class="text-center mt-4 mb-3">More Level {{level}} Exercies</h3>
      <div class="row">


        <div class="col-md-6 col-12" *ngFor="let area of exerciseAreas">
          <h4 class="text-center">Level {{level}} - {{area}}</h4>
          <div class="card mt-3 mb-4 bg-light rounded">
            <div class="card-body">
              <ul class="link-list">
                

                <li *ngFor="
                  let _exercise of getExerciseByArea(
                    levelExercises,
                    area
                  )
                ">
                  <a [routerLink]="[
                  '/activity',
                  'move',
                  'exercise',
                  level,
                  _exercise.strength_exercise_id
                ]"
                  [ngClass]="{active:_exercise.strength_exercise_id == exercise.strength_exercise_id}"
                >
                    <span class="icon-wrap more-link "
                      ><fa-icon [icon]="['fas', 'circle-play']"></fa-icon
                    ></span>
                    <span class="link-label">{{ _exercise.title }}</span>
                    <span class="icon-wrap more-link duo-primary-dark"
                      ><fa-icon
                        [icon]="['fad', 'circle-chevron-right']"
                      ></fa-icon
                    ></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
